(function(){
	'use strict';
    // Open chat
    if(document.querySelector('.open-chat')){
        document.querySelector('.open-chat').addEventListener('click', function(){
            SI_API.showPopup();
        });
    }
}());
